import { Col, FormGroup, Form, Row } from "react-bootstrap";
import FileUploader from "../../../../../@ui/FileUploader";
import {ErrorText} from "../../../../../@ui/ErrorText";

interface AtocImportFieldsProps {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  errors: any;
  atocTouched: boolean;
  setAtocTouched: (touched: boolean) => void;
}

const AtocImportFields = ({
  setFieldValue,
  errors,
  atocTouched,
  setAtocTouched,
}: AtocImportFieldsProps) => {
  return (
    <Row className="justify-content-center">
      <Col className="col-md-10">
        <FormGroup className="w-100 mt-2">
          <Form.Label>Upload ATOC File: </Form.Label>
          <FileUploader
            onClear={() => setFieldValue("atocFile", undefined)}
            onChange={(file) => {
              setFieldValue("atocFile", file);
            }}
            onBlur={(_) => setAtocTouched(true)}
          />
        </FormGroup>
        {errors.atocFile && atocTouched && (
          <ErrorText className="text-danger">ATOC file is required</ErrorText>
        )}
      </Col>
    </Row>
  );
};

export default AtocImportFields;
